import ApiService from '@shared/services/api.service';
import JwtService from '@shared/services/jwt.service';

const AuthenticationService = {
  checkService: async () => ApiService.get('/service_available'),
  getChallenge: async () => ApiService.get('/user/get_reset_password_challenge'),
  forgotPassword: async (body) => ApiService.post('/user/request_reset_password', body),
  resetPassword: async (body) => ApiService.post('/user/reset_password', body),
  getUser: async () => ApiService.get('/user'),
  getImpersonatedUser: async () => ApiService.get('/impersonated_user'),
  refreshToken: async () => ApiService.post('/refresh_token'),
  login: async (bodyParams) => {
    return new Promise((resolve, reject) => {
      ApiService.post('/login', bodyParams)
        .then(
          (data) => {
            resolve(data);
            JwtService.setToken(data.token);
          },
          (error) => {
            reject(error);
          },
        )
        .catch((error) => {
          reject(error);
          JwtService.destroyToken();
        });
    });
  },
  logout: async () => {
    return new Promise((resolve, reject) => {
      ApiService.post('/logout').then(
        (data) => {
          JwtService.destroyToken();
          resolve(data);
        },
        (error) => {
          reject(error);
          JwtService.destroyToken();
        },
      );
    });
  },
};

export default AuthenticationService;
